import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { PropertyType } from "common/report/constants";
import { DateBucketPaneEl } from "./date-bucket-pane";
import { NumericBucketPaneEl } from "./numeric-bucket-pane";
import { StringBucketPaneEl } from "./string-bucket-pane";
export function template() {
  var _a;
  const useNewDesign = !!this.state.segment;
  const propertyType = useNewDesign ? ((_a = this.state.segment.listItemGroup) == null ? void 0 : _a.propertyType) || this.state.segment.propertyType : PropertyType.Number;
  return useNewDesign ? /* @__PURE__ */ jsx("div", {
    sel: ".new-style"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-bucket-pane"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".input-section",
    on: {
      keyup: this.handleKeyUp.bind(this)
    }
  }, propertyType === PropertyType.String || propertyType === PropertyType.List ? /* @__PURE__ */ jsx(StringBucketPaneEl, {
    sel: ".input-pane",
    params: {
      eventNames: this.attr(`event-names`),
      onUpdate: this.handleSegmentUpdate.bind(this),
      ...this.getSegmentParams()
    }
  }) : propertyType === PropertyType.Number ? /* @__PURE__ */ jsx(NumericBucketPaneEl, {
    sel: ".input-pane",
    params: {
      units: this.attr(`units`),
      useNewDesign,
      selectedBucket: this.state.editedBucket || this.attr(`selected-bucket`),
      selectedUnit: this.attr(`selected-unit`),
      maxNumBuckets: this.attr(`max-num-buckets`),
      rangeMin: this.attr(`range-min`),
      header: this.attr(`header`),
      onUpdate: this.handleBucketUpdate.bind(this)
    }
  }) : propertyType === PropertyType.Datetime && /* @__PURE__ */ jsx(DateBucketPaneEl, {
    sel: ".input-pane",
    params: {
      onUpdate: this.handleUnitUpdate.bind(this),
      unit: this.getPropertyUnit()
    }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".footer"
  }, this.attr(`reset-bucket`) && /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".reset-button",
    attrs: {
      elref: `resetButton`,
      theme: ButtonTheme.Tertiary
    },
    on: { click: this.resetInterval.bind(this) }
  }, "Reset"), /* @__PURE__ */ jsx("div", {
    sel: ".core-btn-group"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".cancel-button",
    attrs: {
      theme: ButtonTheme.Tertiary,
      elref: `cancelButton`
    },
    on: { click: this.close.bind(this) }
  }, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".apply-button",
    attrs: {
      disabled: this.submitDisabled(),
      theme: ButtonTheme.Primary,
      elref: `applyButton`
    },
    on: { click: this.applyBucketSelections.bind(this) },
    hook: { insert: (vnode) => this.handleSubmitInsert(vnode.elm) }
  }, "Apply"))))) : /* @__PURE__ */ jsx("div", {
    sel: ".mp-bucket-pane"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-bucket-pane-content"
  }, /* @__PURE__ */ jsx(NumericBucketPaneEl, {
    sel: ".input-pane",
    params: {
      units: this.attr(`units`),
      useNewDesign,
      selectedBucket: this.state.editedBucket || this.attr(`selected-bucket`),
      selectedUnit: this.attr(`selected-unit`),
      maxNumBuckets: this.attr(`max-num-buckets`),
      rangeMin: this.attr(`range-min`),
      header: this.attr(`header`),
      onUpdate: this.handleBucketUpdate.bind(this)
    },
    on: {
      keyup: this.handleKeyUp.bind(this)
    }
  })), this.attr(`reset-bucket`) && /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".mp-bucket-pane-btn",
    attrs: {
      elref: `resetButton`
    },
    on: { click: this.resetInterval.bind(this) }
  }, "Reset"), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".mp-bucket-pane-btn",
    attrs: {
      disabled: this.submitDisabled(),
      theme: ButtonTheme.Primary,
      elref: `applyButton`
    },
    on: { click: this.applyBucketSelections.bind(this) }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".apply-text"
  }, "Apply")));
}
